import RestKeywordController from '../../../hooks/RestKeywordController'
import { useSearchContext } from '../../../context/SearchCacheContext'
import { useSearchParams } from 'react-router-dom'
import { useCallback, useEffect } from 'react'
import RestProjectController from '../../../hooks/RestProjectController'
import useExportData from '../../../hooks/useExportData'

const OpportunityKeywordsController = (model) => {

  // Hooks
  const { rest } = RestProjectController();

  useEffect(()=> {
    handleSearchProjects(null)
  }, [])


  // Funtions

  // Applu params when any of the filter changes
  const handleFilterUpdate = (name, from, to, action) => {
    model.setFilter((prevItems) => {
      const newItems = new Map([...prevItems]);

      // Initialize an object to store filter values directly
      const payload = {};

      if (action === "delete") {
        // Remove the filter keys from the Map
        newItems.delete(`${name}From`);
        newItems.delete(`${name}To`);
        newItems.delete(`${name}`);
      } else if (name === 'intention') {
        newItems.set(`${name}`, action);
      } else {
        if (from) newItems.set(`${name}From`, from);
        if (to) newItems.set(`${name}To`, to);
      }

      // Convert the Map into an object with only raw values
      newItems.forEach((value, key:any) => {
        payload[key] = value; // Store only the value, no extra object
      });

      // Update model state (if needed)
      model.setFilter(newItems);

      return new Map(newItems); // Ensure React detects changes
    });
  };


  const handleSearchProjects = useCallback(async (cleanParams: boolean) => {
    const params = { };

    model.setIsLoading((prev) => ({ ...prev, projects: true }))
    rest({ params, endpoint: 'getProjects' })
      .then((data) => {
        model.setProjectsData(data)
      })
      .catch((error) => {
        console.error(`Error:`, error);
      })
      .finally(() => {
        model.setIsLoading((prev) => ({ ...prev, projects: false }))
      })

  }, []);


  // perform the search
  const handleSearchBtn = useCallback(async (cleanParams: boolean) => {
    const params = { project: model.projectSelected, url: model.url, mode: model.modeFilter };

    if(model.sortModel.length===1){
      params['field'] = model.sortModel[0].field
      params['sort'] = model.sortModel[0].sort
    }

    model.filter.forEach((value, key) => {
      params[key] = value;
    });

    model.setIsLoading((prev) => ({ ...prev, search: true }))
    model.setIsLoading((prev) => ({ ...prev, keywords: true }))
    rest({ params, endpoint: 'getKeywords' })
      .then((data) => {
        model.setKeywordsData(data);
      })
      .catch((error) => {
        console.error(`Error:`, error);
      })
      .finally(() => {
        model.setIsLoading((prev) => ({ ...prev, keywords: false }))
        model.setIsLoading((prev) => ({ ...prev, search: false }))
      })

  }, [model.project, model.url, model.filter, model.sortModel, model.paginationModel, model.modeFilter]);


  const { fetchExportProjectsKeywords, isLoading: isExportLoading } = useExportData();
  // Export to excel
  const handleExportExcel = async () => {
    model.setIsLoading({ export: true })
    const params = { project: model.projectSelected, url: model.url, mode: model.modeFilter, dateFrom: model.filter.get('dateFrom'), dateTo: model.filter.get('dateTo')}
    await fetchExportProjectsKeywords({ ...params });
    model.setIsLoading({ export: false })
  }


  return {
    handleSearchBtn,
    handleFilterUpdate,
    handleExportExcel
  }
}

export default OpportunityKeywordsController

/*
import { useCallback, useEffect, useMemo, useState } from 'react';
import { extractRootDomain } from '../../../utils/Utils';
import * as CONSTANTS from '../../../utils/Constants';
import { useProjectsData } from '../../../hooks/useProjectsData'

const OpportunityKeywordsController = (model) => {

  useEffect(() => {
    if(model.project && model.project.property){
      model.setUrl(getDomain(model.project.property))
    }
  }, [model.project]);

  const handleModeFilter = (value) => model.setFilterMode(value);

  const convertOpportunityKeywordsResponse = (response) => {
    return response.items.map(item => ({
      keyword: item.keys[0],
      url: item.keys[1],
      ...item
    }));
  };

  const getKeywords = useCallback(async () => {
    if (!model.project || !model.url || !model.url?.includes(extractRootDomain(model.project.property))) return;
    const data = await model.fetchKeywords({ url: model.url, project: model.project.property, ...model.rangesDate, ...model.handleFiltersApply() });
    if (data) {
      const formattedData = convertOpportunityKeywordsResponse(data);
      model.setDataKeyword(formattedData);
    }
    handleModeFilter(CONSTANTS.ALL_FILTER_MODE_OPPORTUNITY[0]);
  }, [model.project, model.url, model.rangesDate, model.fetchKeywords, model.handleFiltersApply]);

  const fetchGetKeywords = async () => await getKeywords();


  const getDomain = (domain) => {
    const extractedDomain:string = extractRootDomain(domain)
    return extractedDomain.indexOf('http')!==-1?extractedDomain:`https://${extractedDomain}/`
  }

  const validateProjectUrlMemoized = useMemo(() => {
    if (model.url && model.project.property) return !model.url.includes(extractRootDomain(model.project.property)) || model.loadingKeywords;
    return true;
  }, [model.url, model.project, model.loadingKeywords]);

  const handleExport = async () => {
    if (!model.url) return;
    const data = { url: model.url, project: model.project.property, ...model.rangesDate, ...model.handleFiltersApply() };
    await model.fetchExportProjectsKeywords(data);
  };


    return {
    fetchGetKeywords,
    handleModeFilter,
      validateProjectUrlMemoized,
    handleExport
  }
}

export default OpportunityKeywordsController

 */